import { createGlobalStyle } from 'styled-components';
import tokens from './tokens';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root { min-height: 100%; }

  body {
    margin: 0;
    font-family: ${tokens.font.body};
    color: ${tokens.color.text};
    background: ${tokens.color.bg};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  img { max-width: 100%; }

  a { color: ${tokens.color.brand}; }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    background: ${tokens.color.surfaceAlt};
    border-radius: 4px;
    padding: 1px 4px;
  }
`;

export default GlobalStyle;
